module.exports = __webpack_public_path__ + "img/Electrical Panels with breakers.a0075cc9.png";